import styled from 'styled-components'

export const Page = styled.div`
  max-width: 720px;
  margin: 40px auto;
  padding: 24px;
  font-family: Inter, sans-serif;
  color: #202020;
`

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  margin: 0 0 8px;
`

export const Intro = styled.p`
  margin: 0 0 32px;
  font-size: 14px;
  line-height: 20px;
  color: rgba(32, 32, 32, 0.7);
`

export const FieldLabel = styled.label`
  display: block;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 16px;
  color: #202020;
`

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 220px;
  border: 1px solid rgba(32, 32, 32, 0.2);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  padding: 16px;
  outline: none;
  color: #202020;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  font-family: Inter, sans-serif;
  resize: vertical;

  &:hover {
    box-shadow: 0 2px 8px -2px rgba(32, 32, 32, 0.1);
  }

  &:focus {
    border: 1px solid #0aa1f4;
    box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05), 0 0 0 4px rgba(10, 161, 244, 0.1);
  }
`

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`

export const FileName = styled.span`
  font-size: 14px;
  color: rgba(32, 32, 32, 0.7);
`

export const Hint = styled.p`
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 20px;
  color: rgba(32, 32, 32, 0.7);
`

export const Actions = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
`

export const ErrorText = styled.p`
  margin-top: 16px;
  font-size: 14px;
  line-height: 20px;
  color: #e11900;
`

export const ReportBox = styled.div`
  margin-top: 24px;
  padding: 16px;
  border: 1px solid rgba(32, 32, 32, 0.1);
  border-radius: 4px;
  background: rgba(32, 32, 32, 0.02);
  font-size: 14px;
  line-height: 20px;
`

export const ModalText = styled.p`
  margin: 0 0 24px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #202020;
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`

export const ReportPre = styled.pre`
  white-space: pre-wrap;
  font-family: Inter, sans-serif;
  font-size: 13px;
  line-height: 20px;
  margin: 12px 0 0;
`
